/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {Injectable} from '@angular/core';
import {OverlayContainer} from '@angular/cdk/overlay';

@Injectable({ providedIn: 'root' })
export class DashGisOverlayContainer extends OverlayContainer {
    public setContainerElement(containerElement: HTMLElement): void {
        this._containerElement = containerElement;
    }
}
